module.exports = __webpack_public_path__ + "static/media/approved.e4fea00d.svg";